import { useCallback, useEffect, useState } from 'react';
import { CommercialSalesGoalService } from '../services/CommercialSalesGoalService';
import type { CommercialSalesGoalSnapshot } from '../utils/salesGoalCounter';

export function useCommercialSalesGoal(month: string, enabled = true) {
  const [snapshot, setSnapshot] = useState<CommercialSalesGoalSnapshot | null>(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => {
    setReloadKey((current) => current + 1);
  }, []);

  useEffect(() => {
    if (!enabled) {
      setSnapshot(null);
      setLoading(false);
      setError(null);
      return;
    }

    let ignore = false;
    setLoading(true);
    setError(null);

    CommercialSalesGoalService.get(month)
      .then((next) => {
        if (!ignore) {
          setSnapshot(next);
        }
      })
      .catch((caught: unknown) => {
        if (!ignore) {
          setSnapshot(null);
          setError(caught instanceof Error ? caught.message : 'Não foi possível carregar a meta de vendas.');
        }
      })
      .finally(() => {
        if (!ignore) {
          setLoading(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, [enabled, month, reloadKey]);

  return { snapshot, loading, error, refetch };
}
